import React from "react";
import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { PositionListLayout } from "./components/PositionListLayout";
import { PositionDetailLayout } from "./components/PositionDetailLayout";
import { PositionEmployeeList } from "./components/PositionEmployeeList";
import { PositionHistoryList } from "./components/PositionHistoryList";
import { PositionList } from "./components/PositionList";
import { PositionListInactive } from "./components/PositionListInactive";
import { PositionTasks } from "../../src/employee_tasks/components/PositionTasks";
import { useSettingValue } from "../utils/Hooks";

export const LinkPosition = ({ position, children }) => {
  if (!position) return null;

  return <Link to={`/cargos/${position.id}`}>{children || position.name}</Link>;
};

export const PositionRoutes = () => {
  let { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/:position_id(\\d+)`}>
        <PositionDetailLayout />
      </Route>
      <Route path={path}>
        <PositionListLayout />
      </Route>
    </Switch>
  );
};

export const PositionDetailRoutes = ({ position_id }) => {
  let { url, path } = useRouteMatch();
  const isPositionTasksEnabled = useSettingValue("T013_POSITION_TASKS_ENABLED");

  return (
    <Switch>
      <Route path={`${path}/historico`}>
        <PositionHistoryList position_id={position_id} />
      </Route>
      <Route path={`${path}/funcionarios`}>
        <PositionEmployeeList position_id={position_id} />
      </Route>
      {isPositionTasksEnabled && (
        <Route path={`${path}/tarefas`}>
          <PositionTasks positionId={position_id} />
        </Route>
      )}

      <Redirect to={`${url}/funcionarios`} />
    </Switch>
  );
};

export const PositionListRoutes = ({ search, positionData }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/inativos`}>
        <PositionListInactive search={search} />
      </Route>
      <Route path={path}>
        <PositionList positionData={positionData} />
      </Route>
    </Switch>
  );
};
